module.exports = __webpack_public_path__ + "housingStatic/img/page_center_bottom_shadow.05435b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upper/page_center_bottom_shadow.png
// module id = VGct
// module chunks = 2